/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GeoPolygon } from '../models/GeoPolygon';
import type { GeoPolygon_GeoPolygonDocument } from '../models/GeoPolygon_GeoPolygonDocument';
import type { GeoPolygon_GeoPolygonInput } from '../models/GeoPolygon_GeoPolygonInput';
import type { GeoPolygon_GeoPolygonPayload } from '../models/GeoPolygon_GeoPolygonPayload';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class GeoPolygonService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @deprecated
     * Creates a GeoPolygon resource.
     * Deprecated. Use POST /geo/tiling/polygons/{geoType}/{geoId} instead.
     * @param requestBody The new GeoPolygon resource
     * @returns GeoPolygon GeoPolygon resource created
     * @throws ApiError
     */
    public apiGeotilingpolygonsPost(
        requestBody: GeoPolygon_GeoPolygonInput,
    ): CancelablePromise<GeoPolygon> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/geo/tiling/polygons',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input`,
                403: `Forbidden`,
                422: `Unprocessable entity`,
            },
        });
    }
    /**
     * Get geo area
     * Get polygons list for specified geo area
     * @param geoType GeoPolygon identifier
     * @param geoId GeoPolygon identifier
     * @returns GeoPolygon_GeoPolygonDocument GeoPolygon resource
     * @throws ApiError
     */
    public apiGeotilingpolygonsGeoTypeGeoIdGet(
        geoType: string,
        geoId: string,
    ): CancelablePromise<GeoPolygon_GeoPolygonDocument> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/geo/tiling/polygons/{geoType}/{geoId}',
            path: {
                geoType: geoType,
                geoId: geoId,
            },
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Create new geo area
     * Create polygons list and update tiles set for specified geo area
     * @param geoType GeoPolygon identifier
     * @param geoId GeoPolygon identifier
     * @param requestBody The new GeoPolygon resource
     * @returns GeoPolygon GeoPolygon resource created
     * @throws ApiError
     */
    public apiGeotilingpolygonsGeoTypeGeoIdPost(
        geoType: string,
        geoId: string,
        requestBody: GeoPolygon_GeoPolygonPayload,
    ): CancelablePromise<GeoPolygon> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/geo/tiling/polygons/{geoType}/{geoId}',
            path: {
                geoType: geoType,
                geoId: geoId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input`,
                403: `Forbidden`,
                422: `Unprocessable entity`,
            },
        });
    }
    /**
     * Update geo area
     * Updates polygons list and tiles set for specified geo area
     * @param geoType GeoPolygon identifier
     * @param geoId GeoPolygon identifier
     * @param requestBody The updated GeoPolygon resource
     * @returns GeoPolygon GeoPolygon resource updated
     * @throws ApiError
     */
    public apiGeotilingpolygonsGeoTypeGeoIdPatch(
        geoType: string,
        geoId: string,
        requestBody: GeoPolygon_GeoPolygonPayload,
    ): CancelablePromise<GeoPolygon> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/geo/tiling/polygons/{geoType}/{geoId}',
            path: {
                geoType: geoType,
                geoId: geoId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input`,
                403: `Forbidden`,
                404: `Resource not found`,
                422: `Unprocessable entity`,
            },
        });
    }
}
